export function putToken(token: string|undefined) {
    if(token === undefined) localStorage.removeItem("authToken")
    else localStorage.setItem("authToken", token)
}

export function getToken() {
    return localStorage.getItem("authToken") ?? undefined
}
